import { axiosInstance } from "@/api/axiosInstance";
import { BASE_API } from "@/helpers/constants";
import {
  AddonsApi,
  AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest,
  AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest,
} from "@/api/client";

const api = new AddonsApi(undefined, BASE_API, axiosInstance);

export const getAllAddonPlans = async (
  payload: AddonsApiAddonsViewsNinjaAddonGetAllAddonPlansRequest
) => {
  return api.addonsViewsNinjaAddonGetAllAddonPlans.bind(api)(payload);
};

export const getAllSubscribedAddons = async (
  payload: AddonsApiAddonsViewsNinjaAddonGetAllSubscribedAddonsRequest
) => {
  return api.addonsViewsNinjaAddonGetAllSubscribedAddons.bind(api)(payload);
};
